<template>
  <div class="product-catalog">
    <div class="buttons ml-1">
      <PrimaryButton
        v-if="showMonthButton === true"
        @click.native="changeList('30')"
        :class="[{ active: selectedDayCount == '30' }]"
        >{{ $t('global.month', ['1']) }}</PrimaryButton
      >
      <PrimaryButton
        v-if="show1YearButton === true"
        @click.native="changeList('365')"
        :class="[{ active: selectedDayCount == '365' }]"
        >{{ $t('global.year', ['1']) }}</PrimaryButton
      >
      <PrimaryButton
        v-if="show3YearButton === true"
        @click.native="changeList('1095')"
        :class="[{ active: selectedDayCount == '1095' }]"
        >{{ $t('global.year', ['3']) }}</PrimaryButton
      >
    </div>

    <div class="list">
      <List
        :header="header"
        :data="data"
        :loading="loading"
        @click="clickField"
      >
        <!-- <template v-slot:item.checkbox="{ item }">
          <Checkbox label=""
                    :id="item.id" />
        </template> -->

        <template v-slot:item.name="{ item }">
          <span>{{
            `
            ${item.name} 
            ${
              item.args && (item.args.cpu || item.args.ram || item.args.disk)
                ? `(${item.args.cpu ? item.args.cpu + ' CPU, ' : ''}
              ${
                item.args.ram
                  ? $customFunctions.convertMBtoGB(item.args.ram) + ' GB RAM, '
                  : ''
              } 
              ${
                item.args.disk
                  ? $customFunctions.convertMBtoGBWithHalfPoint(
                      item.args.disk
                    ) + ' GB DISK'
                  : ''
              })`
                : ''
            }
            `
          }}</span>
        </template>

        <template v-slot:item.subscription_type="{ item }">
          <span>{{
            item.subscription_type ? $capitalize(item.subscription_type) : 'N/A'
          }}</span>
        </template>

        <template v-slot:item.currency_code="{ item }">
          <span>{{
            item.currency_code ? item.currency_code.toUpperCase() : 'N/A'
          }}</span>
        </template>

        <template v-slot:item.price="{ item }">
          <span>{{
            item.price
              | calculatePrice(
                selectedDayCount,
                item.currency_code.toUpperCase(),
                item.subscription_type
              )
          }}</span>
        </template>

        <template v-slot:item.contract_price="{ item }">
          <span class="color-blue">{{
            item.contract_price
              | calculatePrice(
                selectedDayCount,
                item.currency_code.toUpperCase(),
                item.subscription_type
              )
          }}</span>
        </template>
      </List>
    </div>

    <ProductCatalogPriceInfo
      v-if="selectedProductCatalog"
      :selectedCatalog="selectedProductCatalog"
      :selectedCatalogDayCount="selectedDayCount"
    ></ProductCatalogPriceInfo>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'

export default {
  name: 'ProductCatalog',
  props: {
    productId: String | Number,
    showMonthButton: {
      type: Boolean | String,
      default: true,
    },
    show1YearButton: {
      type: Boolean | String,
      default: true,
    },
    show3YearButton: {
      type: Boolean | String,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      header: [
        // { text: '', value: 'checkbox', size: '50px' },
        { text: 'global.name', value: 'name', size: '3fr', clicked: true },
        {
          text: 'global.subscription',
          value: 'subscription_type',
          clicked: true,
        },
        { text: 'global.currency', value: 'currency_code', clicked: true },
        { text: 'global.price', value: 'price', clicked: true, size: '150px' },
        {
          text: 'global.contractPrice',
          value: 'contract_price',
          size: '100px',
          clicked: true,
        },
      ],
      data: [],
      selectedProductCatalog: '',
      selectedDayCount: '30',
    }
  },
  created() {
    this.getProductCatalogs()
  },
  filters: {
    calculatePrice(val, selectedDayCount, currencyCode, subscriptionType) {
      if (val) {
        if (subscriptionType == 'hourly') {
          val = selectedDayCount > 0 ? (val * 24 * 31).toFixed(2) : val
        } else {
          val = (val * 1).toFixed(2)
        }
        return val.toString().replace('.', ',') + ' ' + currencyCode
      } else return '-'
    },
  },
  methods: {
    changeList(dayCount) {
      this.selectedDayCount = dayCount
      this.getProductCatalogs()
    },
    getProductCatalogs() {
      this.getProductCatalogList()
        .then((res) => {
          this.setProductCatalogList(res)
        })
        .catch(() => {
          this.data = []
        })
    },
    getProductCatalogList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(
          `marketplace/${this.productId}/catalogs?contractLength=${this.selectedDayCount}&page=1&start=0&limit=25&position=price|asc`
        )
          .then(({ data }) => {
            resolve(data)
            this.loading = false
          })
          .catch((err) => {
            reject(err)
            this.loading = false
          })
      })
    },
    setProductCatalogList(res) {
      if (res && res.data && res.data.length > 0) {
        this.data = res.data
      }
    },
    clickField(item) {
      this.selectedProductCatalog = item
      this.$emit('selectedItem', item, this.selectedDayCount)
      this.$emit('closeSecondModal', false)
    },
  },
  components: {
    ProductCatalogPriceInfo: () =>
      import('@/components/ProductCatalogPriceInfo'),
  },
}
</script>

<style lang="scss">
.product-catalog {
  .buttons {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .list {
    margin-bottom: 20px;

    .color-blue {
      color: #00baf2;
    }
  }
}

.product-catalog-total-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &-content {
    width: 100%;
    max-width: 250px;
    padding: 20px;
    border: 1px solid #e5eaee;
    border-radius: 6px;

    .item {
      display: flex;

      .name {
        width: 100%;
        max-width: 100px;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        color: #b5b5c3;
      }

      .result {
        flex: 1;
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        text-align: right;
        color: #464e5f;
      }
    }
  }
}
</style>
